<template>
    <v-modal
        :title="modalContactWhatsApp ? 'Contacto por WhatsApp' : 'Contactarse por WhatsApp'"
        :visible="modalContactWhatsApp"
        @close="modalClose"
        fullScreen
        width="500"
    >
        <form @submit.prevent="changeMessages" class="modal-contact">
          <p>
            Para enviar un mensaje al profesional ingrese los datos:
          </p>

            <div class="modal-contact__control">
              <label>Nombre:</label>
              <input required type="text" v-model="messages.name" ref="nameInput" v-autofocus="autofocusValue" @blur="onBlurInput" autofocus/>
            </div>
            <div class="modal-contact__control">
              <label>Email:</label>
              <input required type="email" v-model="messages.email" ref="emailInput" />
            </div>
            <div class="modal-contact__control">
                <label>Teléfono:</label>
                <input required type="tel" v-model="messages.phone" ref="phoneInput" />
            </div>
            <div class="modal-contact__control none">
                <label>Mensaje:</label>
                <textarea required rows="6" v-model="messages.message" ref="messageInput"></textarea>
            </div>
            <div class="modal-contact__actions">
                <button @click="modalClose" class="button" type="button">Cancelar</button>
                <button class="button modal-contact__actions__whatsapp" type="submit">
                  <img class="modal-contact__actions__whatsapp__icon" src="/img/whatsapp.svg" />
                  Enviar Whatsapp
                </button>
            </div>
            <p class="modal-contact__terms">
                Al enviar este mensaje se aceptan los
                <router-link :to="`${path.toLowerCase()}/terminos-y-condiciones`">términos y condiciones</router-link>, así como la
                <router-link :to="`${path.toLowerCase()}/politica-de-privacidad`">política de privacidad</router-link>.
            </p>
            <v-loader border="4" size="40" v-show="loader" />
            <div class="modal-contact__messages" v-show="message !== null">

              <span v-show="message == 'success'">
              <a class="button-whats-app-mobile"
                :href="'https://api.whatsapp.com/send?phone=' + customerBranch.mobile + '&text=Hola, me contacto por la siguiente publicación en el portal *' + this.$appSettings.appName + '*: ' +  this.$appSettings.appUrl + this.$route.path"
                title="Enviar mensaje por WhatsApp"
                target="_blank"
                >
                <img class="button-whats-app__icon" src="/img/whatsapp.svg" /> Mensaje a {{ customerBranch.name }}
              </a>

              <a class="button-whats-app-desktop"
                :href="'https://web.whatsapp.com/send?phone=' + customerBranch.mobile + '&text=Hola, me contacto por la siguiente publicación en el portal *' + this.$appSettings.appName + '*: ' +  this.$appSettings.appUrl + this.$route.path"
                title="Enviar mensaje por WhatsApp"
                target="_blank"
                >
                <img class="button-whats-app__icon" src="/img/whatsapp.svg" /> Mensaje a {{ customerBranch.name }}
              </a>










                <!-- <p>
                  https://api.whatsapp.com/send?phone={{ customerBranch.mobile }}&text=Hola, me contacto por la siguiente publicación en el portal {{ this.$appSettings.appName }}: {{ this.$appSettings.appUrl }} {{ this.$route.path }}
                </p> -->




                <!-- <p>Nombre: <strong>{{ customerBranch.name }}</strong></p>
                <p>Sucursal: <strong>{{ customerBranch.customer }}</strong></p>
                <p>Email: <strong>{{ customerBranch.email }}</strong></p>
                <p v-show="customerBranch.mobile">Celular: <strong>{{ customerBranch.mobile }}</strong></p>
                <p>Telefono: <strong>{{ customerBranch.phone1 }}</strong></p>
                <p>Domicilio: <strong>{{ customerBranch.address }}, {{ customerBranch.zone3Description }}, {{ customerBranch.zone2Description }}, {{ customerBranch.zone1Description }}, {{ customerBranch.zone0Description }}</strong></p> -->

                <div class="modal-contact__actions">
                  <button @click="modalClose" class="button" type="button">Cancelar</button>
                </div>
              </span>

              <span v-show="message == 'error'">
                Oops! Algo salió mal, vuelve a intentarlo
              </span>

            </div>
        </form>
    </v-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { messages } from '@/services/ApiMapaprop'
import Messages from '../models/Messages.js'

export default {
    props: {
        data: { type: Object, required: true }
    },
    // mounted(){
    //   console.group("vContactWhatsApp.vue: mounted()");
    //   console.log(this.data)
    // },
    data() {
        return {
            loader: false,
            message: null,
            messages: new Messages(),
            customerBranch: this.data.branch,
            autofocusValue: true
        }
    },
    computed: {
        ...mapGetters({
            modalContactWhatsApp: 'modals/modalContactWhatsApp',
            path: 'path'
        })
    },
    watch: {
        modalContactWhatsApp(response) {
            this.messages.message = 'Mensaje Automatico: El visitante presionó el boton WhatsApp'
        }
    },
    methods: {
        modalClose() {
            this.$store.commit('modals/modalHandler', { name: 'modalContactWhatsApp', boolean: false })
            this.message = null
            this.autofocusValue = true
        },
        changeMessages() {
            this.loader = true
            this.messages.referer = this.$appSettings.appUrl
            this.messages.propertyHash = this.data.propertyHash
            this.messages.url = this.$appSettings.appUrl + this.$route.path
            this.messages.userAgent = navigator.userAgent
            this.POSTmessages()
            // axios
                // .get('https://api.ipstack.com/check?access_key=9c5ae013a2155928d2211207fbcc93b1')
                // .then((response) => {
                //     this.messages.ip = response.data.ip
                //     setTimeout(() => {
                //         this.POSTmessages()
                //     }, 500)
                // })
                // .catch((error) => {
                //     setTimeout(() => {
                //         this.loader = true
                //         this.message = 'error'
                //     }, 1000)
                // })
        },
        async POSTmessages() {
            try {
                const response = await messages(this.messages)
                this.messages = new Messages()

                // console.log(response)

                setTimeout(() => {
                  this.loader = true
                  this.message = 'success'
                }, 1000)

            } catch (error) {
              setTimeout(() => {
                this.loader = true
                this.message = 'error'
              }, 1000)
              console.log(error)
            }
            console.groupEnd()
        },
        onBlurInput() {
            this.autofocusValue = false
        }
    }
}
</script>

<style lang="scss">
.modal-contact {
    position: relative;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr;
    p {
      font-weight: bold;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
    &__control {
        label {
            display: inline-block;
            margin-bottom: 0.5rem;
        }
        input,
        textarea {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
        }

        input {
        }
        textarea {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }

    }
    &__actions {
        display: flex;
        justify-content: flex-end;
        button {
            width: auto;
            &:nth-of-type(1) {
                margin-right: 1rem;
            }
        }
        &__whatsapp {
          background-color:#25d366 !important;
          color: #fff;
          width: 100%;
          &__icon{
            width: 1rem;
            height: 1rem;
            margin-right:1rem;
          }
        }
    }
    &__terms {
        font-size: 0.8rem;
        a {
            font-size: 0.8rem;
            color: #c9d700;
            &:hover {
                color: #888888;
            }
        }
    }

    &__messages {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        .button-whats-app {
          padding-left: 1rem;
          padding-right: 1rem;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          height: 4rem;
          outline: none;
          width: 100%;
          border: none;
          margin: auto;
          background-color:#25d366;
          color:#FFF;
          // border-radius: 50%;
          // text-align:center;
          // font-size:30px;
          // box-shadow: 0.1rem 0.1rem 0.3rem #999;
            &__icon{
              width: 1rem;
              height: 1rem;
              margin-right:1rem;
              // margin-left:1rem;
            }
        }
        span {
            text-align: center;
        }
        h2 {
          font-size: 1.5rem;
          line-height: 2.2rem;
          margin-bottom:1rem;
          text-align: center;
        }
        p {
          margin-bottom:0.5rem;
          text-align: left;
        }
        // strong {
        //   font-weight: bold;
        // }
    }

    .v-loader {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #ffffff;
    }
    .button-whats-app-mobile {display:none}
    .button-whats-app-desktop {
      padding-left: 1rem;
      padding-right: 1rem;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      height: 4rem;
      outline: none;
      width: 100%;
      border: none;
      margin: auto;
      background-color:#25d366;
      color:#FFF;
      // border-radius: 50%;
      // text-align:center;
      // font-size:30px;
      // box-shadow: 0.1rem 0.1rem 0.3rem #999;
        &__icon{
          width: 1rem;
          height: 1rem;
          margin-right:1rem;
          // margin-left:1rem;
        }
      }
      @media (max-width: 576px) {

        .button-whats-app-desktop {display:none}
        .button-whats-app-mobile {
          padding-left: 1rem;
          padding-right: 1rem;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          height: 4rem;
          outline: none;
          width: 100%;
          border: none;
          margin: auto;
          background-color:#25d366;
          color:#FFF;
          // border-radius: 50%;
          // text-align:center;
          // font-size:30px;
          // box-shadow: 0.1rem 0.1rem 0.3rem #999;
            &__icon{
              width: 1rem;
              height: 1rem;
              margin-right:1rem;
              // margin-left:1rem;
            }
          }
      }




}
</style>
